import { OrganizationStaffFragment } from "gql/graphql";
import { Hidable, Value } from "@/shared/value";

/** Штатная численность подразделения — сколько единиц числится по штату. */
export function OrganizationStaff({
  data,
}: {
  data?: Hidable<OrganizationStaffFragment>;
}) {
  return (
    <Value data={data}>
      {(organization) => <span>{organization.staff}</span>}
    </Value>
  );
}
